export enum UserTypes {
    PATIENT = 'person',
    CLIENT = 'company'
}
